import { UnitSuggestion } from '@/store/useFallbackStore'
import { Address } from './Address'

export class Location {
  id: string
  idMotion: number
  idRdsl?: number
  name: string
  address: Address
  type: string
  unitIds?: number[]

  constructor({ id, idMotion, name, address, type } = {} as any) {
    this.id = id
    this.idMotion = idMotion
    this.name = name
    this.address = new Address(address)
    this.type = type
  }

  convertFromAlgolia = (data) => {
    this.id = String(data.objectID)
    this.idRdsl = Number(data.id)
    this.idMotion = Number(data.idMotion)
    this.name = data.name
    this.address = new Address({
      city: data.address?.city,
      neighborhood: data.address?.neighborhood,
      state: data.address?.state
    })
    this.type = data.type
    this.unitIds = data.unitIds

    return this
  }

  convertFromStartup = (data) => {
    this.id = data.locationId
    this.idRdsl = data.id
    this.idMotion = Number(data.idMotion)
    this.name = data.name
    this.address = new Address({
      city: data.address?.city,
      neighborhood: data.address?.neighborhood,
      state: data.address?.state
    })
    this.type = data.type
    this.unitIds = this._getUnitIdsStartup(data)

    return this
  }

  convertFromFallback = (data: UnitSuggestion) => {
    this.id = data.locationId
    this.idRdsl = Number(data.id)
    this.idMotion = data.idMotion
    this.name = data.name
    this.type = data.type
    this.address = new Address({
      street: data.street,
      neighborhood: data.neighborhood,
      city: data.city,
      state: data.state,
      zipCode: data.zipCode
    })

    return this
  }

  _getUnitIdsStartup(data) {
    if (!data.units || data.units.lenght === 0) {
      return
    }

    return data.units.map((unit) => unit.id)
  }
}
